import drive from '../../components/1elements/Icons/png/google-drive.png'
import gmail from '../../components/1elements/Icons/png/google-gmail.png'
import calendar from '../../components/1elements/Icons/png/google-calendar.png'
import chat from '../../components/1elements/Icons/png/google-chat.png'
import meet from '../../components/1elements/Icons/png/google-meet.png'
import docs from '../../components/1elements/Icons/png/google-docs.png'
import sheets from '../../components/1elements/Icons/png/google-sheets.png'
import slides from '../../components/1elements/Icons/png/google-slides.png'

export const apps = [
  {
    name: 'Gmail',
    link: 'https://gmail.com',
    icon: gmail
  },
  {
    name: 'Drive',
    link: 'https://drive.google.com',
    icon: drive
  },
  {
    name: 'Calendar',
    link: 'https://calendar.google.com',
    icon: calendar
  },
  {
    name: 'Chat',
    link: 'https://chat.google.com',
    icon: chat
  },
  {
    name: 'Meet',
    link: 'https://meet.google.com',
    icon: meet
  },
  {
    name: 'Docs',
    link: 'https://docs.google.com/document',
    icon: docs
  },
  {
    name: 'Sheets',
    link: 'https://docs.google.com/spreadsheets',
    icon: sheets
  },
  {
    name: 'Slides',
    link: 'https://docs.google.com/presentation',
    icon: slides
  }
]
